/* eslint-disable security/detect-object-injection */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PinState {
  pinned: { [key: number]: boolean }; // Key-value for folder ID and its pinned state
}

const initialState: PinState = {
  pinned: {},
};

export const pinSlice = createSlice({
  name: "pin",
  initialState,
  reducers: {
    togglePin: (state, action: PayloadAction<number>) => {
      const folderId = action.payload;
      state.pinned[folderId] = !state.pinned[folderId]; // Toggle pin state
    },
  },
});

export const { togglePin } = pinSlice.actions;
export default pinSlice.reducer;
